const host = window.location.origin

const graphql = () => `${host}/gql/v1/graphql`
const api = (path: string) => `${host}/api/${path}`
const transcriptApi = (path: string) => `${host}/transcript-api/${path}`
const apim = (path: string) =>
  `${process.env.REACT_APP_VIRA_AUTHN_APIM_ENDPOINT}/${path}`

export const ENDPOINTS = {
  LOGIN: apim("login"),
  LOGOUT: apim("logout"),
  REGISTER: apim("register"),
  CHANGE_EMAIL: apim("change-email/"),
  CHANGE_PASSWORD: apim("change-password"),
  REQUEST_PASSWORD_RESET: api("util/reset-password/request"),
  RESET_PASSWORD: apim("reset-password"),
  DELETE_ACCOUNT_LOGIN: apim("delete-account-login"), //TODO: Appears to be unused, consider removing
  DEACTIVATE_MOBILE_USER: api("user/deactivate-mobile-user"),
  EMAIL_STAFF_INVITE: api("user/invite-staff"),
  SCHEDULE_CONNECT_PRACTITIONER: api("schedule/connect-practitioner"),
  SCHEDULE_DISCONNECT_PRACTITIONER: api("schedule/disconnect-practitioner"),
  SEND_SMS_VERIFICATION_CODE: api("user/send-sms-code"),
  CHECK_VERIFICATION_CODE: api("user/check-code"),
  GET_CURRENT_APP_VERSIONS: api("util/most-recent-app-version"),
  EMAIL_HOME_SAFETY_CHECKLIST: api("util/email-home-safety-checklist"),
  DOWNLOAD_HOME_SAFETY_CHECKLIST: api("util/download-home-safety-checklist"),
  GRAPHQL: graphql(),
  WS_GRAPHQL: graphql().replace("http", "ws"),
  ASSIGN_DEFAULT_USER_FEATURE_FLAGS: api("user/assign-default-feature-flags"),
  CREATE_INVITE_CODE: api("invites/client-invitation"),
  TRANSCRIPT_SESSIONS: transcriptApi("sessions"),
  TRANSCRIPT_RECORD: transcriptApi("sessions/record"),
  TRANSCRIPT_UPLOAD: transcriptApi("sessions/upload"),
  TRANSCRIPT_MANUAL_SESSION: transcriptApi("sessions/manual"),
  TRANSCRIPT_CLIENTS: transcriptApi("clients"),
}
